import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ManagementApiService } from '../management-api.service';
import {ItemTypeClassesActions} from '@emm/management/store/item-type-classes/item-type-classes.actions';

@Injectable({
    providedIn: 'root'
})
export class ItemTypeClassesEffects {

    load$ = createEffect(() =>
        this.actions$.pipe(
            ofType(ItemTypeClassesActions.load),
            switchMap(() =>
                this.api.getAllItemTypeClasses().pipe(
                    map((itemTypeClasses) => ItemTypeClassesActions.loadSuccess({ itemTypeClasses })),
                    catchError(({ error }) => of(ItemTypeClassesActions.loadFailure({ error })))
                )
            )
        )
    );

    constructor(private actions$: Actions, private api: ManagementApiService) {}

}
